import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=63ff195a&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"
import style0 from "./CustomersPage.vue?vue&type=style&index=0&id=63ff195a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff195a",
  null
  
)

export default component.exports